export const IMAGES_BASE_URL = process.env.REACT_APP_IMAGES_URL
export const MAIN_URL = process.env.REACT_APP_RAYCHAT_MAIN_URL
export const WIDGET_MAIN_URL = process.env.REACT_APP_RAYCHAT_WIDGET_MAIN_URL
export const WIDGET_SERVICE_URL = process.env.REACT_APP_RAYCHAT_WIDGET_SERVICE_URL
export const SOCKET_URL = process.env.REACT_APP_RAYCHAT_SOCKET_URL
export const LOGO_URL = process.env.REACT_APP_RAYCHAT_LOGO_URL
export const SOUNDS_URL = process.env.REACT_APP_RAYCHAT_SOUNDS_URL
export const UPLOAD_FILE_URL = process.env.REACT_APP_RAYCHAT_UPLOAD_FILE_URL
export const DEFAULT_IMAGE_URL = process.env.REACT_APP_RAYCHAT_DEFAULT_IMAGE_URL
export const NEW_DEFAULT_LOGOS = process.env.REACT_APP_NEW_DEFAULT_LOGOS
export const LANDING_URL = process.env.REACT_APP_RAYCHAT_LANDING_URL
export const ASSETS_BASE_URL = process.env.REACT_APP_RAYCHAT_ASSETS_URL
